"use client";

import React, { useState } from "react";
import "./ProcessContents.scss";
import { processTagTexts } from "../../data/data";
import { processData, specialLayoutContent } from "../../data/data";
import { ReactComponent as Art } from "../../assets/svg/art.svg";

const ProcessContents = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleButtonClick = (index) => {
    setActiveIndex(index);
  };

  const isSpecialLayout = activeIndex <= 3;

  return (
    <>
      <section className="section processBtn" id="processSection">
        <article className="processBtn__container container">
          <h3>ALL PROCESSES {processTagTexts[activeIndex]}</h3>

          <div className="processBtn__container--contents">
            {processTagTexts.map((tag, index) => (
              <button
                key={index}
                type="button"
                className={`processTagBtn ${
                  index === activeIndex ? "active-processTagBtn" : ""
                }`}
                onClick={() => handleButtonClick(index)}
              >
                <span>{tag}</span>
              </button>
            ))}
          </div>
        </article>
      </section>

      <section className="section processContents">
        <article className="processContents__container container">
          <div className="processContents__container--header">
            <h3 className="processContents__subtitle">
              {processData[activeIndex].shortTitle}
            </h3>

            <div className="processContents__title">
              <h3 className="title">{processData[activeIndex].title}</h3>
              <h3 className="subtitle">{processData[activeIndex].subTitle}</h3>
            </div>
          </div>
          {isSpecialLayout ? (
            <div className="processContents__container--special">
              <div className="processContents__container--special-img">
                {specialLayoutContent[activeIndex].images.map(
                  (image, index) => (
                    <figure key={index} className="contents-img">
                      <img
                        src={image}
                        alt="Process"
                        width={1000}
                        height={1000}
                      />
                    </figure>
                  )
                )}
              </div>

              <div className="processContents__container--special-texts">
                {specialLayoutContent[activeIndex].items.map((item, index) => (
                  <div key={index} className="contents-texts-items">
                    <div className="contents-texts-items-title">
                      <p>01</p>
                      <h3>
                        {item.title} <span>{item.subTitle}</span>
                      </h3>
                    </div>

                    <ul className="contents-texts-items-lists">
                      {item.goals.map((goal, goalIndex) => (
                        <li key={goalIndex}>
                          <Art />
                          <span>{goal}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="processContents__container--contents">
              <div className="processContents__container--contents-texts">
                {processData[activeIndex].items.map((item, index) => (
                  <div className="contents-text-title" key={index}>
                    <p>{(index + 1).toString().padStart(2, "0")}</p>
                    <h3>{item}</h3>
                  </div>
                ))}
              </div>

              <div className="processContents__container--contents-img">
                <figure className="contents-img">
                  <img
                    src={processData[activeIndex].Image1}
                    alt="Process"
                    width={1000}
                    height={1000}
                  />
                </figure>

                <figure className="contents-img">
                  <img
                    src={processData[activeIndex].Image2}
                    alt="Process"
                    width={1000}
                    height={1000}
                  />
                </figure>
              </div>
            </div>
          )}
        </article>
      </section>
    </>
  );
};

export default ProcessContents;
